import React from 'react'
import { UseDisclosureReturn } from 'src/hooks/useDisclosure'

export interface ContextProps {
  modalWalletConnector: UseDisclosureReturn
  dropdownAccount: UseDisclosureReturn
}

export const Context = React.createContext<ContextProps>(undefined as any)
